import { connect } from 'react-redux';
import {
  loadDataMap,
  loadDataMapSamples,
  loadDataMapEntry,
  setInitialStateDataMapEditor,
  clearStateToInitial,
  updateDataMapMeta,
  saveDataMapFromForm,
  closeKeyForm,
  addAnotherNewRow,
  onSetSearchTerm,
  clearDataMapSearchResults,
  deleteKey,
  toggleKeyForm,
  onFieldUpdated,
  updateRowBeingAdded,
  deleteNewRow,
  deleteRow,
  undoDeleteRow,
  onSubmitPropertyForm,
  setInsertType,
  setWriteMode,
  onChangeBulkInsert,
  onChangeSelectedFile,
  setDefaultValue,
  setPrimaryKey,
  changeDataMapCell,
  setDynamicDataMapRows,
  onFirstPage,
  onPrevPage,
  onSetPage,
  onNextPage,
  onLastPage,
  setError,
  setContextualSupport,
  unsetContextualSupport,
} from '../../actions';
import DataMapsEditForm from './DataMapsEditForm';
import filter from 'lodash/filter';
import has from 'lodash/has';
import { isReadOnly } from '../../lib/ACLUtils';
import UIUtils from '../../lib/UIUtils';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import * as OLD_PATHS from 'js/constants/pathnames';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { users, dataMaps },
    dataMapEditForm: {
      dataMapObj,
      isKeyFormOpen,
      propBeingEdited,
      propBeingEditedFormerName,
      idOfEditedProp,
      unsavedPrimaryKeyPropertyId,
      isAddingNewRow,
      editedRows,
      deletedRows,
      newRows,
      insertType,
      writeMode,
      bulkText,
      isFileSelected,
      arePropertiesChanged,
      keysPage,
      keysTotalPage,
      dataMapId,
      isTypeStatic,
      buttonLabel,
      popUpFormTitle,
      keysSearch,
      fields,
      saveComplete,
      saveError,
    },
    dataMaps: { samples, searchResults },
    schemaEditor: {
      fromSamples: { fromNested },
    },
    request,
  } = state;
  const dataMapIdParam = UIUtils.extractParamFromURL(ownProps.match);
  const dataMap = dataMapIdParam && dataMaps[dataMapIdParam];
  const dynamicDataMapRows = fromNested ? filter(fromNested) : [];
  const readOnly =
    has(dataMapObj, 'id') && has(dataMapObj, 'access_roles') ? isReadOnly(dataMapObj) : false;
  const owner =
    readOnly && has(dataMapObj, 'owner') && has(users, dataMapObj.owner)
      ? users[dataMapObj.owner]
      : null;
  const dataMapSamples = samples.id === dataMapIdParam ? samples.flat : [];
  const dataMapSearchResults = searchResults.id === dataMapIdParam ? searchResults.flat : null;

  return {
    isLoadingSamples: !!request.GET_DATA_MAP_SAMPLES_REQUEST,
    isLoadingDataMap: !!request.GET_DATA_MAP_REQUEST,
    isLoadingSearchResults: !!request.GET_DATA_MAP_ENTRY_REQUEST,
    dataMapIdParam,
    dataMap,
    dynamicDataMapRows,
    dataMapObj,
    dataMapSamples,
    dataMapSearchResults,
    isKeyFormOpen,
    propBeingEdited,
    propBeingEditedFormerName,
    idOfEditedProp,
    unsavedPrimaryKeyPropertyId,
    isAddingNewRow,
    editedRows,
    deletedRows,
    newRows,
    insertType,
    writeMode,
    bulkText,
    isFileSelected,
    arePropertiesChanged,
    keysPage,
    keysTotalPage,
    dataMapId,
    isTypeStatic,
    buttonLabel,
    popUpFormTitle,
    keysSearch,
    fields,
    readOnly,
    owner,
    saveComplete,
    saveError,
  };
};

const DataMapsEditFormContainer = connect(mapStateToProps, {
  loadDataMap,
  loadDataMapSamples,
  loadDataMapEntry,
  setInitialStateDataMapEditor,
  clearStateToInitial,
  updateDataMapMeta,
  saveDataMapFromForm,
  closeKeyForm,
  addAnotherNewRow,
  onSetSearchTerm,
  clearDataMapSearchResults,
  deleteKey,
  toggleKeyForm,
  onFieldUpdated,
  updateRowBeingAdded,
  deleteNewRow,
  deleteRow,
  undoDeleteRow,
  onSubmitPropertyForm,
  setInsertType,
  setWriteMode,
  onChangeBulkInsert,
  onChangeSelectedFile,
  setDefaultValue,
  setPrimaryKey,
  changeDataMapCell,
  setDynamicDataMapRows,
  onFirstPage,
  onPrevPage,
  onSetPage,
  onNextPage,
  onLastPage,
  setError,
  setContextualSupport,
  unsetContextualSupport,
})(DataMapsEditForm);

DataMapsEditFormContainer.screenConfig = {
  screenName: 'DataMapsEditFormContainer',
  domain: 'integrate',
  path: [
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_DATA_MAPS}/new`,
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_DATA_MAPS}/:id/edit`,
  ],
  pageTitle: 'Lookups',
};

export default DataMapsEditFormContainer;
